// components/Login.tsx
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { login, clearAuthFeedback } from "../../features/auth/authSlice";
import type { RootState, AppDispatch } from "../../app/store";
import "./Login.css";
import PasswordInput from "../../components/PasswordInput";

const Login: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  const { status, error, message, isAuthenticated } = useSelector(
    (state: RootState) => state.auth
  );

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/dashboard");
    }
  }, [isAuthenticated, navigate]);

  useEffect(() => {
    // Clear messages after ~4 seconds
    if (message || error) {
      const timer = setTimeout(() => dispatch(clearAuthFeedback()), 4000);
      return () => clearTimeout(timer);
    }
  }, [message, error, dispatch]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    dispatch(login({ email, password }));
  };

  return (
    <div className="login-container">
      <form className="login-card" onSubmit={handleSubmit}>
        <div className="login-logo-wrap">
          <img src="/assets/images/Trim_logo.png" alt="Logo" className="login-logo" />
        </div>

        {(message || error) && (
          <p
            style={{
              textAlign: "center",
              color: error ? "#e53e3e" : "#38a169",
              marginBottom: "1rem",
            }}
          >
            {error || message}
          </p>
        )}

        <input
          className="login-input"
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value.trim())}
          required
          disabled={status === "loading"}
        />

        <PasswordInput
          className="login-input"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          disabled={status === "loading"}
        />

        <p
          className="forgot-link"
          onClick={() => navigate("/forgot-password")}
        >
          Forgot Password?
        </p>

        <button
          className="login-button"
          type="submit"
          disabled={status === "loading"}
        >
          {status === "loading" ? "Logging in..." : "Login"}
        </button>
      </form>
    </div>
  );
};

export default Login;